import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
  {
    path: '/',
    label: 'Home',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
        <path d="M3 12L12 3l9 9M5 10v9a1 1 0 001 1h4v-5h4v5h4a1 1 0 001-1v-9" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    path: '/cellar',
    label: 'Cellar',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
        <path d="M9 3h6l1 7H8L9 3zM8 10c0 4-2 6-2 9h12c0-3-2-5-2-9" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 16h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    path: '/add',
    label: 'Add',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v8M8 12h8" strokeLinecap="round" />
      </svg>
    ),
    isAction: true,
  },
  {
    path: '/recommend',
    label: 'Suggest',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
        <path d="M12 2C8 2 5 5 5 9c0 3 1.5 5.5 3.5 7L9 20h6l.5-4C17.5 14.5 19 12 19 9c0-4-3-7-7-7z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 20h6M10 23h4" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    path: '/profile',
    label: 'Me',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" strokeLinecap="round" />
      </svg>
    ),
  },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/'}
          className={({ isActive }) =>
            [
              'bottom-nav-item',
              item.isAction ? 'bottom-nav-action' : '',
              isActive ? 'active' : '',
            ]
              .filter(Boolean)
              .join(' ')
          }
        >
          <span className="bottom-nav-icon">{item.icon}</span>
          <span className="bottom-nav-label">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
